import {useId} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Chip, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useTranslation} from "react-i18next";

export default function ExcludedOrderProducts({products, lines = []}) {
    const {t} = useTranslation(), id = useId();
    if (!products.length) return null;
    const byLine = new Map(lines.map(line => [line.lineId, line]));
    return <Accordion variant="outlined" sx={{mb: 3, borderRadius: 2}} slotProps={{transition: {unmountOnExit: true}}}>
        <AccordionSummary expandIcon={<ExpandMoreIcon/>} id={`${id}-header`} aria-controls={`${id}-content`}>
            <Typography fontWeight={600}>{t("OrderExcludedProducts")} ({products.length})</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>{t("OrderExcludedProductsHelp")}</Typography>
            <Box component="ul" sx={{listStyle: "none", m: 0, p: 0}}>
                {products.map(product => {
                    const line = byLine.get(product.orderId);
                    return <Box component="li" key={product.orderId} sx={{py: 1.5, borderTop: 1, borderColor: "divider"}}>
                        <Box sx={{display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap"}}>
                            <Typography fontWeight={500}>{product.productName}</Typography>
                            <Chip size="small" variant="outlined" label={t(line?.confirmedQuantity === 0 ? "Rejected" : "OrderExcludedProductStatus")}/>
                        </Box>
                        <Typography variant="caption" color="text.secondary">{product.productCode}</Typography>
                        {line?.requestedQuantity > 0 && <Typography variant="body2">{t("ConfirmationRequested")}: {line.requestedQuantity}</Typography>}
                        {line?.reason && <Typography variant="body2">{t("ReviewReductionReason")}: {line.reason}</Typography>}
                    </Box>;
                })}
            </Box>
        </AccordionDetails>
    </Accordion>;
}
